import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const NombreUnidadMedidaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='UNIDAD MEDIDA' htmlFor='producto-adicional-input-nombreUMed' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='nombreUnidadDeMedida'>
          {({ field }) => (
            <Form.InputText
              {...field}
              disabled
              isInvalid={iTouched && iError}
              id='producto-adicional-input-nombreUMed'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(NombreUnidadMedidaFormGroup)
